<template>
  <base-select
    :value="value"
    :options="options"
    label="name"
    searchable
    :taggable="false"
    placeholder="Улица"
    :disabled="disabled"
    :clearSelectOnDisabled="clearSelectOnDisabled"
    :clearable="clearable"
    :autocompleteAtOne="autocompleteAtOne"
    @onScroll="onScroll"
    @search="onSearch"
    @input="changeValue"
    @search:blur="searchPremisesList = []"
  >
  </base-select>
</template>

<script>
import { BaseSelect } from '@/components/Custom/select';
import api from '@/api';
import { debounce } from "lodash";

export default {
  name: "FilterThoroughfare",
  data() {
    return {
      limit: 25,
      offset: 0,
      pageNext: true,
      list: [], // Дефолтный лист дополняемый данными при прокрутке
      searchList: [], // Временный лист при поиске через строку
      inProgress: false,
    }
  },
  components: {
    BaseSelect
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    autocompleteAtOne: {
      type: Boolean,
      default: false,
    },
    clearSelectOnDisabled: {
      type: Boolean,
      default: true,
    },
    localityId: {
      type: String,
      default: null,
    },
  },
  computed: {
    options() {
      return this.searchList.length > 0 ? this.searchList : this.list;
    },
  },
  watch: {
    localityId(val, oldVal) {
      if (!!this.value && !val || oldVal && val && val !== oldVal) {
        this.$emit('input', null);
      }
      this.limit = 25;
      this.offset = 0;
      this.pageNext = true;
      this.list = [];
      this.fetchPremisesList()
    }
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    // Запрос при вводе в строку
    search: debounce((loading, search, vm) => {

      const params = {
        name: search,
        limit: 10,
        offset: 0,
        localityId: vm.localityId,
      };
      api.user.getThoroughfareList(params)
        .then((data) => {
          vm.searchList = data.data;
          loading(false);
        }).catch(() => {
        loading(false);
      })
    }, 350),

    onScroll(e) {
      if (this.searchList.length > 0) return;
      if (Math.round(e.target.scrollHeight - e.target.scrollTop - 150) <= Math.round(e.target.clientHeight)) {
        this.fetchPremisesList()
      }
    },

    async fetchPremisesList() {
      if (!this.pageNext || this.inProgress) return;
      this.inProgress = true;
      const params = {
        limit: this.limit,
        offset: this.offset,
        localityId: this.localityId,
      };
      const resp = await api.user.getThoroughfareList(params);
      this.list = [ ...this.list, ...resp.data ];
      this.offset += 25;
      this.pageNext = resp.data.length === this.limit;
      this.inProgress = false;
    },

    changeValue(value) {
      if (value) {
        this.$emit('input', value);
        this.searchList = [];
      } else {
        this.$emit('input', null);
      }
    }
  },
}
</script>
